import { RETRY_COUNT } from "@impero-com/common/utils/query_client";

import { usePatchTestingActivitiesTestingActivityId } from "api/generated/testing-activities/testing-activities";
export function usePatchTestingActivityMutation() {
    return usePatchTestingActivitiesTestingActivityId({
        mutation: { retry: RETRY_COUNT },
    });
}
